<script setup lang="ts">
  import type { Benefit } from '@/models/benefit';
  import { useBenefitsMobile } from '@/composables/useBenefitsMobile';
  import BenefitsBenefitCard from './BenefitCard.vue';
  import type { PropType } from 'vue';

  defineProps({
    benefits: {
      type: Array as PropType<Benefit[]>,
      required: true
    },
    heading: {
      type: String,
      default: ''
    }
  });

  const { wrapperRef, titleRef } = useBenefitsMobile();
</script>

<template>
  <div
    ref="wrapperRef"
    class="benefits-section__wrapper">
    <h1
      v-if="heading"
      ref="titleRef"
      class="benefits-section__title"
      v-html="heading" />
    <div
      v-if="benefits.length"
      class="benefits-section__items">
      <BenefitsBenefitCard
        v-for="(benefit, index) in benefits"
        :key="index"
        :benefit="benefit" />
    </div>
  </div>
</template>
